import moment from 'moment';
import groupBy from 'lodash/groupBy';
import {EpisodeDto} from './Item/Item';

export const episodeDtoToDomainObject = (source: any) => {
  const { id, info_ru, info_en, name_ru, name_en, moderators, speakers, timeStart, timeStop, color } = source;
  return { id, info_ru, info_en, name_ru, name_en, moderators, speakers, timeStart, timeStop, color };
};

export const getDates = (streams: any[], locale = 'ru') => {
  // iterate through all episodes and return entries with [date, Array[id]]
  const dataEpisodes = streams.map((x) => x.episode);

  const allEpisodes: any[] = [];

  dataEpisodes.forEach((g) => {
    g.forEach((ep: any) => {
      allEpisodes.push(ep);
    });
  });

  const groupedEpisodes = groupBy(allEpisodes, (episode) => {
    return moment.unix(episode.timeStart).locale(locale).format('DD MMMM');
  });

  return Object.entries(groupedEpisodes).map(([date, episodes]) => {
    return [date, episodes.map((ep) => ep.id)];
  });
};

export const getEpisodesLength = (streams: any[]): number => {
  let length = 0;
  streams.forEach((s) => {
    length += s.episode.length;
  });
  return length;
};

// export const limitRender = (streams: any[], showMore: number, streamDate: string) =>
//   streams.map((s) => ({
//     episode: s.episode.filter((e: {timeStart: number}) => streamDate === moment.unix(e.timeStart).format('DD MMMM') && episodeDtoToDomainObject(e)).slice(0, showMore),
//     // episode: s.episode.map((e: {timeStart: number}) => episodeDtoToDomainObject(e)).slice(0, showMore),
// }));

export const limitRender = (streams: any[], showMore: number, streamDate: string, locale = 'ru') =>
  streams.map((s) => {
    const episodes: Array<EpisodeDto> = s.episode.reduce((acc: Array<EpisodeDto>, e: {timeStart: number}) => {
      if (streamDate === moment.unix(e.timeStart).locale(locale).format('DD MMMM')) {
        acc.push(episodeDtoToDomainObject(e));
      }
      return acc;
    }, []);
    return {
      id: s.id,
      episode: episodes.slice(0, showMore)
    };
});

